import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RoomType} from '../../../enums/RoomType';
import {CoffeeConfig} from '../../../classes/CoffeeConfig';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';
import {BookingOption} from '../../../enums/BookingOption';

@Component({
  selector: 'app-coffee-config-edit',
  styleUrls: ['./coffee-config-edit.component.scss'],
  templateUrl: './coffee-config-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CoffeeConfigEditComponent implements OnInit {

  @Input() coffeeConfig: CoffeeConfig;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  types: string[];
  offices: Office[];
  bookingOptions = Object.keys(BookingOption);

  public coffeeConfigForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private officeService: OfficeService) {}

  ngOnInit(): void {

    this.types = Object.keys(RoomType);

    if (this.coffeeConfig) {
      this.coffeeConfigForm = this.formBuilder.group({
        id: [this.coffeeConfig.id],
        officeId: [this.coffeeConfig.officeId, Validators.required],
        bookingOption: [this.coffeeConfig.bookingOption, Validators.required],
        value: [this.coffeeConfig.value, Validators.required]
      });
    } else {
      this.coffeeConfigForm = this.formBuilder.group({
        id: [''],
        officeId: ['', Validators.required],
        bookingOption: ['', Validators.required],
        value: ['', Validators.required]
      });
    }

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => this.offices = response,
      error: err => console.log(err.error) // TODO handle error
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
